import * as request from "@/utils/request";
import { DefaultConfigs } from "@/common/js/constant";
import { RetrunsData, SimCalcData, SimCalcRes } from "./types";

const baseUrl = `${DefaultConfigs.publicAPIPath}`;

// 收益模拟页面初始渲染信息
export function getReturnsSimulationInfo() {
  return request.get<RetrunsData>(`${baseUrl}/sofipo/v0/main/getSimCalcPageElement`);
}

// 计算模拟利息
export function getEarningCalc(params: SimCalcData): Promise<SimCalcRes> {
  return request.post<SimCalcRes>(`${baseUrl}/sofipo/v0/main/earning/calc`, params);
}
